import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  Snowflake,
  ArrowLeft,
  ScrollText,
} from "lucide-react";

const sections = [
  {
    title: "1. Anbieter",
    body: (
      <>
        <p className="font-semibold text-slate-900">Grömitzer Eiszeit</p>
        <p>MK MOMENTS</p>
        <p>Majid Kalantary</p>
        <p>Niedernstr. 11</p>
        <p>23628 Krummesse</p>
        <p>Deutschland</p>
        <p className="mt-3">Telefon: 0155 61642249</p>
        <p>E-Mail: info@groemitzereiszeit.de</p>
      </>
    ),
  },
  {
    title: "2. Geltungsbereich",
    body: (
      <p>
        Diese Allgemeinen Geschäftsbedingungen gelten für alle Bestellungen und Buchungen über die
        Website der Grömitzer Eiszeit, insbesondere für den Erwerb von Eintrittskarten,
        Eventtickets, Buchungen von Eisstockschießbahnen sowie den Kauf von Gutscheinen.
      </p>
    ),
  },
  {
    title: "3. Vertragsabschluss",
    body: (
      <>
        <p>
          Die Darstellung der Leistungen auf der Website stellt kein rechtlich bindendes Angebot dar,
          sondern eine Aufforderung zur Bestellung.
        </p>
        <p className="mt-3">
          Mit Abschluss der Buchung gibt der Kunde ein verbindliches Angebot ab. Der Vertrag kommt
          mit erfolgreicher Zahlung und Versand der Buchungsbestätigung per E-Mail zustande.
        </p>
      </>
    ),
  },
  {
    title: "4. Preise und Zahlung",
    body: (
      <>
        <p>Alle Preise verstehen sich in Euro inklusive der gesetzlichen Mehrwertsteuer.</p>
        <p className="mt-3">
          Die Zahlung erfolgt über die im Bestellprozess angebotenen Zahlungsmethoden (z. B.
          PayPal). Erst nach erfolgreicher Zahlung besteht ein Anspruch auf die gebuchte Leistung.
        </p>
      </>
    ),
  },
  {
    title: "5. Tickets und Veranstaltungen",
    body: (
      <>
        <p className="font-semibold text-slate-800">5.1 Gültigkeit</p>
        <p>Tickets sind ausschließlich für den gebuchten Termin gültig.</p>
        <p className="font-semibold text-slate-800 mt-4">5.2 Rückgabe und Umtausch</p>
        <p>Ein Umtausch oder eine Rückgabe von Tickets ist ausgeschlossen.</p>
        <p className="font-semibold text-slate-800 mt-4">5.3 Übertragbarkeit</p>
        <p>
          Tickets sind grundsätzlich übertragbar, sofern keine personalisierten Tickets ausgegeben
          wurden.
        </p>
        <p className="font-semibold text-slate-800 mt-4">5.4 Einlass</p>
        <p>
          Die Buchungsbestätigung mit QR-Code ist beim Einlass vorzuzeigen (digital oder
          ausgedruckt). Der QR-Code ist nur einmal gültig. Bei mehrfacher Nutzung verliert das
          Ticket seine Gültigkeit.
        </p>
      </>
    ),
  },
  {
    title: "6. Eisstockschießen",
    body: (
      <>
        <p>Buchungen für Eisstockschießbahnen gelten für den gebuchten Zeitraum.</p>
        <p className="mt-3">
          Bei verspätetem Erscheinen besteht kein Anspruch auf Verlängerung der Nutzungszeit.
        </p>
        <p className="mt-3">
          Die Nutzung erfolgt auf eigene Gefahr. Den Anweisungen des Personals ist Folge zu leisten.
        </p>
      </>
    ),
  },
  {
    title: "7. Gutscheine",
    body: (
      <>
        <p className="font-semibold text-slate-800">7.1 Art des Gutscheins</p>
        <p>Es handelt sich um Wertgutscheine.</p>
        <p className="font-semibold text-slate-800 mt-4">7.2 Gültigkeit</p>
        <p>Gutscheine sind ab Ausstellungsdatum drei Jahre gültig.</p>
        <p className="font-semibold text-slate-800 mt-4">7.3 Einlösung</p>
        <p>
          Gutscheine können ausschließlich für Leistungen der Grömitzer Eiszeit (z. B. Eintritt,
          Eisstockschießen) eingelöst werden. Eine Einlösung für gastronomische Angebote (Speisen
          und Getränke) ist ausgeschlossen.
        </p>
        <p className="font-semibold text-slate-800 mt-4">7.4 Barauszahlung</p>
        <p>Eine Barauszahlung des Gutscheinwertes ist ausgeschlossen.</p>
      </>
    ),
  },
  {
    title: "8. Widerrufsrecht",
    body: (
      <>
        <p className="font-semibold text-slate-800">8.1 Kein Widerrufsrecht für Tickets und Buchungen</p>
        <p>
          Gemäß § 312g Abs. 2 Nr. 9 BGB besteht kein Widerrufsrecht bei Verträgen zur Erbringung von
          Dienstleistungen im Zusammenhang mit Freizeitbetätigungen, wenn diese für einen bestimmten
          Termin oder Zeitraum erfolgen.
        </p>
        <p className="mt-3">Dies betrifft insbesondere:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li>Eintrittskarten</li>
          <li>Eventtickets (z. B. Silvesterveranstaltungen)</li>
          <li>Eisstockschießen-Buchungen</li>
        </ul>
        <p className="font-semibold text-slate-800 mt-4">8.2 Widerrufsrecht für Gutscheine</p>
        <p>
          Für den Kauf von Gutscheinen besteht ein Widerrufsrecht von vierzehn Tagen ab
          Vertragsschluss, sofern der Gutschein noch nicht eingelöst wurde.
        </p>
      </>
    ),
  },
  {
    title: "9. Rücktritt / Stornierung",
    body: (
      <p>
        Eine Stornierung oder Umbuchung von Tickets und Buchungen ist grundsätzlich ausgeschlossen.
        Ein Anspruch auf Rückerstattung besteht nicht, außer bei vollständigem Ausfall der
        Leistung.
      </p>
    ),
  },
  {
    title: "10. Ausfall / Änderungen",
    body: (
      <>
        <p>
          Bei witterungsbedingten Einflüssen, technischen Störungen oder aus Sicherheitsgründen kann
          es zu Einschränkungen oder Unterbrechungen des Betriebs kommen.
        </p>
        <p className="mt-3">
          Bei vollständigem Ausfall der gebuchten Leistung wird der Ticketpreis erstattet.
        </p>
      </>
    ),
  },
  {
    title: "11. Haftung",
    body: (
      <>
        <p>Die Nutzung der Eisbahn erfolgt auf eigene Gefahr.</p>
        <p className="mt-3">
          Für Garderobe, Wertgegenstände oder persönliche Gegenstände wird keine Haftung
          übernommen.
        </p>
        <p className="mt-3">
          Die Haftung ist, soweit gesetzlich zulässig, auf Vorsatz und grobe Fahrlässigkeit
          beschränkt.
        </p>
      </>
    ),
  },
  {
    title: "12. Verhalten auf der Eisbahn",
    body: (
      <>
        <p>Es gilt die jeweils vor Ort ausgehängte Eisbahnordnung.</p>
        <p className="mt-3">
          Den Anweisungen des Personals ist jederzeit Folge zu leisten. Bei Verstößen kann ein
          Ausschluss vom Betrieb erfolgen, ohne Anspruch auf Rückerstattung.
        </p>
      </>
    ),
  },
  {
    title: "13. Datenschutz",
    body: (
      <p>
        Informationen zur Verarbeitung personenbezogener Daten sind in der{" "}
        <Link to="/datenschutz" className="text-sky-600 underline hover:text-sky-700">
          Datenschutzerklärung
        </Link>{" "}
        der Website einsehbar.
      </p>
    ),
  },
  {
    title: "14. Schlussbestimmungen",
    body: (
      <>
        <p>Es gilt das Recht der Bundesrepublik Deutschland.</p>
        <p className="mt-3">
          Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der
          übrigen Bestimmungen unberührt.
        </p>
      </>
    ),
  },
];

const AGB = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-sky-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-lg border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3 text-slate-600 hover:text-sky-500 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück zur Startseite</span>
          </Link>
          <div className="flex items-center gap-3">
            <Snowflake className="w-6 h-6 text-sky-500" />
            <span
              className="font-semibold text-slate-900"
              style={{ fontFamily: "Playfair Display" }}
            >
              Grömitzer Eiszeit
            </span>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-sky-100 mb-6">
            <ScrollText className="w-8 h-8 text-sky-600" />
          </div>
          <h1
            className="text-4xl md:text-5xl font-medium tracking-tight text-slate-900 mb-4"
            style={{ fontFamily: "Playfair Display" }}
          >
            Allgemeine Geschäftsbedingungen
          </h1>
          <p className="text-slate-500">Grömitzer Eiszeit</p>
        </div>

        {/* Wichtige Hinweise Box */}
        <Card className="border-0 shadow-lg mb-8 bg-gradient-to-br from-sky-50 to-blue-50" data-testid="wichtige-hinweise">
          <CardContent className="p-6 md:p-8">
            <h2
              className="text-xl font-semibold text-slate-900 mb-5"
              style={{ fontFamily: "Playfair Display" }}
            >
              Wichtige Hinweise auf einen Blick
            </h2>
            <div className="space-y-5 text-slate-700">
              <div className="flex gap-3">
                <span className="text-2xl">🎟️</span>
                <div>
                  <p className="font-semibold text-slate-900">Tickets & Buchungen</p>
                  <p className="text-sm">
                    Tickets sind <strong>termingebunden</strong> und vom Umtausch sowie Widerruf
                    ausgeschlossen.
                  </p>
                </div>
              </div>
              <div className="flex gap-3">
                <span className="text-2xl">🎫</span>
                <div>
                  <p className="font-semibold text-slate-900">Gutscheine</p>
                  <p className="text-sm">
                    Gutscheine sind Wertgutscheine, <strong>3 Jahre gültig</strong> und nicht
                    auszahlbar. Eine Einlösung ist ausschließlich für Leistungen der{" "}
                    <strong>Eisbahn</strong> möglich – nicht für Gastronomie.
                  </p>
                </div>
              </div>
              <div className="flex gap-3">
                <span className="text-2xl">📱</span>
                <div>
                  <p className="font-semibold text-slate-900">Einlass</p>
                  <p className="text-sm">
                    Die Bestätigungs-E-Mail mit QR-Code dient als Ticket und ist beim Einlass
                    vorzuzeigen.
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-xl">
          <CardContent className="p-8 md:p-12">
            {sections.map((sec) => (
              <section key={sec.title} className="mb-8">
                <h2
                  className="text-xl font-semibold text-slate-900 mb-4"
                  style={{ fontFamily: "Playfair Display" }}
                >
                  {sec.title}
                </h2>
                <div className="text-slate-600 leading-relaxed space-y-1">{sec.body}</div>
              </section>
            ))}

            <div className="border-t border-slate-200 pt-6 mt-10">
              <p className="text-slate-500 text-sm text-center">(Stand: 2026)</p>
            </div>
          </CardContent>
        </Card>

        <div className="text-center mt-8">
          <Link to="/">
            <Button className="h-12 px-8 rounded-full bg-sky-500 hover:bg-sky-600 text-white font-semibold">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </main>

      <footer className="bg-slate-900 text-white py-8 px-6 mt-16">
        <div className="max-w-7xl mx-auto text-center text-slate-500 text-sm">
          <p>© 2026 Grömitzer Eiszeit. Alle Rechte vorbehalten.</p>
        </div>
      </footer>
    </div>
  );
};

export default AGB;
